import { Fieldset as DigdirFieldset, FieldsetDescription, FieldsetLegend, } from "@digdir/designsystemet-react";
const Fieldset = DigdirFieldset;
Fieldset.displayName = "Fieldset";
export { Fieldset, FieldsetDescription, FieldsetLegend, };
//# sourceMappingURL=fieldset.js.map